export const removeHyphen = (phoneNum: string) => {
  if (phoneNum === undefined) return phoneNum;
  return phoneNum?.replace(/-/gi, "");
};

export const parseURLParameters = (url: string) => {
  const params: any = {};
  const query = url.substring(url.indexOf("?") + 1);
  const pairs = query.split("&");

  for (const pair of pairs) {
    const [key, value] = pair.split("=");
    params[key] = decodeURIComponent(value);
  }

  return params;
};

export const checkBusinessLicenseNumber = (registrationNumber: string) => {
  if (!registrationNumber || registrationNumber.length !== 10) {
    return false;
  }

  const valueMap = registrationNumber.split("").map((item) => parseInt(item, 10));
  const multiply = [1, 3, 7, 1, 3, 7, 1, 3, 5];

  const checkSum = multiply.reduce((sum, value, index) => sum + value * valueMap[index], 0);
  const lastDigit = Math.floor((multiply[8] * valueMap[8]) / 10);
  const totalSum = checkSum + lastDigit;
  return Math.floor(valueMap[9]) === (10 - (totalSum % 10)) % 10;
};
